const config = {
  jiraAPI: '/rest/api/2',
  appPrefix: '[Testomat.io]',
  mainBranchSlug: 'main'
};

export default config;
